import React, { useState, useEffect } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import AddSupplierModal from "../Master/Add/AddSupplierModal";
import BankSuggestionBox from "../CommonComp/BankSuggestionBox";
import ViewSupplier from "../Master/ViewSupplier";
import axios from 'axios';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import { Link, useParams, useNavigate } from 'react-router-dom';
import CustomDateInput from '../CommonComp/CustomDateInput';
import Swal from 'sweetalert2';

const PayBillsEdit = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [tableRow, setTableRow] = useState([]);
    const [bills, setBills] = useState(0);
    const [selectedSupplier, setSelectedSupplier] = useState('');
    const [payingAmount, setPayingAmount] = useState(0);
    const [checkedRows, setCheckedRows] = useState([]);
    const accessToken = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('user_id');
    const [bankInfo, setBankInfo] = useState(null);
    const [supplierInfo, setSupplierInfo] = useState(null);
    const [ledgerId, setLedgerId] = useState(null);
    const id = useParams();
    const [formData, setFormData] = useState({
        supplier: '',
        delivery_date: '',
        delivery_id: '',
        details: '',
        transactionRef: ''
    });
    const navigateToPurchaseList = useNavigate();
    const getRowBalanceBase = (row) => {
        const ledgerBalance = parseFloat(row.balance);
        const rowValue = parseFloat(row.value);
        if (!isNaN(ledgerBalance) && ledgerBalance > 0) return ledgerBalance;
        if (!isNaN(rowValue)) return rowValue;
        return 0;
    };

    const parseMoney = (v) => {
        if (v === null || v === undefined || v === '') return NaN;
        return parseFloat(String(v).replace(/,/g, '').trim());
    };

    const roundMoney = (n) => {
        const v = parseMoney(n);
        if (Number.isNaN(v)) return NaN;
        return Math.round(v * 100) / 100;
    };

    const formatMoneyStr = (n) => {
        if (n === null || n === undefined || n === '') return '';
        let v = typeof n === 'number' ? n : parseMoney(n);
        if (Number.isNaN(v)) {
            v = Number(String(n).replace(/,/g, '').trim());
        }
        if (!Number.isFinite(v)) return '';
        const cents = Math.round(v * 100);
        return (cents / 100).toFixed(2);
    };

    const rowInPaymentScope = (idx, rows, selectedRows) =>
        selectedRows.includes(idx) || (parseFloat(rows[idx]?.pay) || 0) > 0;

    const formatLedgerBalanceForRow = (bill, rows, selectedRows) => {
        const base = roundMoney(getRowBalanceBase(bill));
        if (Number.isNaN(base)) return '';
        const pay = parseFloat(bill.pay) || 0;
        if (isCreditRow(bill)) {
            return Math.max(0, Math.round((base - pay) * 100) / 100).toFixed(2);
        }
        if (String(bill.type || '').toUpperCase() === 'INV') {
            const credits = getCreditsByPurchase(rows, selectedRows);
            const credit = credits[bill.purchase_id] || 0;
            return Math.max(0, Math.round((base - credit - pay) * 100) / 100).toFixed(2);
        }
        return Math.max(0, base).toFixed(2);
    };

    const computePaymentSummary = (rows, selectedRows) => {
        const byPurchase = {};
        rows.forEach((row, idx) => {
            if (!rowInPaymentScope(idx, rows, selectedRows)) return;
            const pid = row.purchase_id || `_row_${idx}`;
            if (!byPurchase[pid]) {
                byPurchase[pid] = { invBalance: 0, creditPay: 0, cashPay: 0 };
            }
            const pay = parseFloat(row.pay) || 0;
            if (isCreditRow(row)) {
                byPurchase[pid].creditPay += pay;
            } else if (String(row.type || '').toUpperCase() === 'INV') {
                byPurchase[pid].invBalance += getRowBalanceBase(row);
                byPurchase[pid].cashPay += pay;
            }
        });
        let payingTotal = 0;
        let remainingTotal = 0;
        let invBillTotal = 0;
        Object.values(byPurchase).forEach((g) => {
            payingTotal += g.creditPay + g.cashPay;
            invBillTotal += g.invBalance;
            remainingTotal += Math.max(0, Math.round((g.invBalance - g.creditPay - g.cashPay) * 100) / 100);
        });
        return {
            payingAmount: Math.round(payingTotal * 100) / 100,
            remaining: Math.round(remainingTotal * 100) / 100,
            totalInvBill: Math.round(invBillTotal * 100) / 100,
        };
    };

    const summaryBalanceDiff = () => computePaymentSummary(tableRow, checkedRows).remaining;

    const isPayInputDisabled = (bill) => {
        const b = roundMoney(bill.balance);
        return Number.isNaN(b) || b <= 0;
    };

    const getMaxPayForRow = (row) => {
        const b = parseMoney(row.balance);
        if (!Number.isNaN(b)) return Math.max(0, Math.round(b * 100) / 100);
        const g = getRowBalanceBase(row);
        return Math.max(0, Math.round(g * 100) / 100);
    };

    const isCreditRow = (row) => String(row.type || '').toLowerCase() === 'credit';

    const getCreditsByPurchase = (rows, selectedRows) => {
        const map = {};
        rows.forEach((row, idx) => {
            if (!rowInPaymentScope(idx, rows, selectedRows) || !isCreditRow(row)) return;
            const pid = row.purchase_id;
            if (!pid) return;
            map[pid] = (map[pid] || 0) + (parseFloat(row.pay) || 0);
        });
        return map;
    };

    useEffect(() => {
        if (!accessToken) {
            window.location.href = '/login';
            return;
        }

        setSelectedSupplier(id.id);
        setSupplierInfo(id.id);
        axios.get(`${config.api_url}/ws-get-suppliers`)
            .then(response => {
                if (response.data.supplier && Array.isArray(response.data.supplier)) {
                    setSuppliers(response.data.supplier);
                } else {
                    console.error('Unexpected data format:', response.data);
                    setSuppliers([]);
                }
            })
            .catch(error => {
                console.error('Error fetching suppliers:', error);
            });


        axios.get(`${config.api_url}/ws-edit-po-details/${id.id}`)
            .then(response => {
                if (response.data.success) {
                    const rows = Array.isArray(response.data.purchase) ? response.data.purchase : [];
                    const mappedRows = rows.map((row) => ({
                        ...row,
                        id: row.ledger_id ?? row.id ?? row.purchase_ledger_id,
                        purchase_id: row.purchase_id,
                        pay: '',
                    }));
                    const preCheckedRows = [];
                    const totalPay = 0;
                    const totalBill = 0;
                    const inputData = rows[0] || {};
                    setTableRow(mappedRows);
                    setCheckedRows(preCheckedRows);
                    setPayingAmount(totalPay);
                    setBills(totalBill);
                    setFormData({
                        supplier: inputData.supplier_id || '',
                        delivery_date: inputData.date,
                        delivery_id: inputData.bank_id,
                        details: inputData.details,
                        transactionRef: inputData.transaction_ref
                    });
                    setSupplierInfo(inputData.supplier_id || '');
                    setSelectedSupplier(inputData.supplier_id || '');
                    setLedgerId(inputData.ledger_id || null);
                } else {
                    setTableRow([]);
                    setCheckedRows([]);
                    setPayingAmount(0);
                    setBills(0);
                }
            })
            .catch(error => {
                console.error('Error fetching suppliers:', error);
            });
    }, []);


    const handleSupplierChange = (e) => {
        const supplierId = e.target.value;
        setSelectedSupplier(supplierId);
        setSupplierInfo(supplierId);
        // Fetch bills for the selected supplier
        if (supplierId) {
            setBills(0);
            axios.get(`${config.api_url}/ws-supplier-bills/${supplierId}`) // Adjust the endpoint as necessary
                .then(response => {
                    if (Array.isArray(response.data)) {
                        setBills(0);
                    } else {
                        console.error('Unexpected data format for bills:', response.data);
                        setBills(0); // Reset if not an array
                    }
                })
                .catch(error => {
                    console.error('Error fetching bills:', error);
                    setBills(0); // Reset on error
                });
        } else {
            setBills(0); // Clear bills if no supplier is selected
        }
    };

    const handlePayingAmountChange = (index, value) => {
        const updatedBills = [...bills];
        updatedBills[index].payingAmount = value;
        setBills(updatedBills);
    };

    const fetchData = async () => { };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleBankChange = (selectedBank) => {
        setBankInfo(selectedBank);
    };

    // const handlePayChange = (index, value,balance) => {
    //     const newTableRow = [...tableRow];
    //     newTableRow[index].pay = parseFloat(value) || 0;
    //     newTableRow[index].balance = parseFloat(balance) || 0;
    //     setTableRow(newTableRow);

    //     calculateTotals(newTableRow);
    // };


    const getEffectiveMaxPay = (row, rows, selectedRows) => {
        const base = getMaxPayForRow(row);
        if (row.type === 'INV') {
            const credits = getCreditsByPurchase(rows, selectedRows);
            const credit = credits[row.purchase_id] || 0;
            return Math.max(0, Math.round((base - credit) * 100) / 100);
        }
        return base;
    };

    const handlePayChange = (index, value) => {
        const newTableRow = [...tableRow];
        const row = { ...newTableRow[index] };
        const maxPay = getEffectiveMaxPay(row, tableRow, checkedRows);
        if (value === '' || value === null) {
            row.pay = '';
        } else {
            const num = parseFloat(value);
            if (Number.isNaN(num)) {
                row.pay = '';
            } else if (num < 0) {
                row.pay = 0;
            } else if (num > maxPay + 1e-9) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Pay amount cannot exceed the remaining balance.',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false,
                });
                row.pay = maxPay;
            } else {
                row.pay = Math.round(num * 100) / 100;
            }
        }
        newTableRow[index] = row;
        setTableRow(newTableRow);
        calculateTotals(newTableRow);
    };




    const calculateTotals = (rows, selectedRows = checkedRows) => {
        const summary = computePaymentSummary(rows, selectedRows);
        setPayingAmount(summary.payingAmount);
        setBills(summary.totalInvBill);
    };

    const handleCheckboxChange = (index) => {
        setCheckedRows((prevCheckedRows) => {
            const isChecking = !prevCheckedRows.includes(index);
            const newCheckedRows = isChecking
                ? [...prevCheckedRows, index]
                : prevCheckedRows.filter((rowIndex) => rowIndex !== index);

            if (isChecking) {
                const row = tableRow[index];
                if (row && isCreditRow(row)) {
                    const maxPay = getMaxPayForRow(row);
                    const newTableRow = [...tableRow];
                    newTableRow[index] = { ...row, pay: maxPay };
                    setTableRow(newTableRow);
                    calculateTotals(newTableRow, newCheckedRows);
                    return newCheckedRows;
                }
            }

            calculateTotals(tableRow, newCheckedRows);
            return newCheckedRows;
        });
    };

    const handleSubmit = async (event, action) => {
        event.preventDefault();
        const creditsByPurchase = getCreditsByPurchase(tableRow, checkedRows);
        const overPay = tableRow
            .filter((_, idx) => checkedRows.includes(idx))
            .find((row) => {
                const pay = parseFloat(row.pay) || 0;
                if (isCreditRow(row)) {
                    return pay > getMaxPayForRow(row) + 1e-9;
                }
                if (row.type === 'INV') {
                    const creditApply = creditsByPurchase[row.purchase_id] || 0;
                    return pay + creditApply > getMaxPayForRow(row) + 1e-9;
                }
                return pay > getMaxPayForRow(row) + 1e-9;
            });
        if (overPay) {
            Swal.fire({
                title: 'Error!',
                text: 'Pay amount cannot exceed the remaining balance for a selected bill.',
                icon: 'error',
                timer: 2000,
                showConfirmButton: false,
            });
            return;
        }
        const formData1 = new FormData();
        const supplier = supplierInfo ? supplierInfo : '';
        const bank = bankInfo ? bankInfo.value : '';
        formData1.append('ledgerId', ledgerId);
        formData1.append('supplier_id', supplier);
        formData1.append('date', formData.delivery_date);
        formData1.append('bank_id', bank);
        formData1.append('details', formData.details);
        formData1.append('transaction_ref', formData.transactionRef);
        formData1.append('paying_amount', payingAmount);
        formData1.append('balance', computePaymentSummary(tableRow, checkedRows).remaining);
        // Gather data for the checked rows
        const selectedRowsData = tableRow
            .filter((_, idx) => checkedRows.includes(idx))
            .filter((row) => (parseFloat(row.pay) || 0) > 0)
            .map((row) => ({
                purchase_id: row.purchase_id,
                pay: parseFloat(row.pay) || 0,
                purchase_ledger_id: row.id ?? row.ledger_id ?? row.purchase_ledger_id,
                ledger_type: row.type || '',
                bill_no: row.bill_no || '',
                job_ref: row.job_ref || ''
            }));

        if (selectedRowsData.length === 0) {
            Swal.fire({
                title: 'Error!',
                text: 'Select at least one bill and enter a pay amount.',
                icon: 'error',
                timer: 2500,
                showConfirmButton: false,
            });
            return;
        }

        formData1.append('selected_rows', JSON.stringify(selectedRowsData));
        formData1.append('user_id', user_id);

        const apiUrl = `${config.api_url}/ws-submit-purchase-payment`;

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData1,
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                Swal.fire({
                    title: 'Error!',
                    text: data.message || 'Failed to submit payment data',
                    icon: 'error',
                    timer: 3000,
                    showConfirmButton: false,
                });
                return;
            }

            if (action === 'close') {
                navigateToPurchaseList('/PurchaseLedger');
            }
            else if (action === 'new') {
                setTableRow([]);
                setBankInfo(null);
                setFormData({
                    supplier: '',
                    delivery_date: '',
                    delivery_id: '',
                    details: '',
                    transactionRef: ''
                });
                // setDetails('');
                // setTransactionRef('');
                // setCustomerInfo(null);
                // setDeliveryDate('');
                // setPayingAmount(0);
                // setBills(0);
                // setBankInfo('');
            }
        } catch (error) {
        }
    };

    return (
        <div>
            <Header />
            <ViewSupplier accessToken={accessToken} />
            <AddSupplierModal fetchData={fetchData} />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt;
                            <a href="/Dashboard">Dashboard</a> &gt;
                            <span className="last-crumb">Pay Bills Edit</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <form id='new_sales_order'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-lg-12 col-sm-12">
                                <div className="show-order-area dashboard">
                                    <div style={{ marginBottom: '20px', float: 'left' }}>
                                        <div className="newsalesorderform">
                                            <div style={{ float: "right", width: "100%" }}>
                                                <a href="#" className="create-catalogue-btn" data-bs-toggle="modal"
                                                    data-bs-target="#add-supplier" ><i className='fa fa-plus'></i>&nbsp;New Supplier
                                                </a>
                                            </div>
                                            <hr />
                                            <div className="row mb-3 padd-l-13px">
                                                <div className="col-6 col-lg-6 col-sm-6">
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="supplier" className="col-form-label">Select Supplier <span className='red'>*</span> </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <select
                                                                className="form-control"
                                                                id="supplier"
                                                                name="supplier"
                                                                value={formData.supplier}
                                                                onChange={(e) => {
                                                                    handleSupplierChange(e);
                                                                    handleChange(e);
                                                                }}
                                                                disabled
                                                            >
                                                                <option value="">Select Supplier</option>
                                                                {suppliers.map(supplier => (
                                                                    <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                                                                ))}
                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="delivery_date" className="col-form-label">Date </label>
                                                        </div>
                                                        <div className="col-8 col-lg-3 col-sm-3">
                                                            <CustomDateInput name="delivery_date" id="delivery_date" value={formData.delivery_date} onChange={handleChange} className="form-control" />
                                                        </div>
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="bank" className="col-form-label">Bank </label>
                                                        </div>
                                                        <div className="col-8 col-lg-3 col-sm-3">
                                                            <BankSuggestionBox onBankChange={handleBankChange} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="details" className="col-form-label">Details </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" name='details' value={formData.details} onChange={handleChange} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-lg-6 col-sm-6">
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="transaction_ref" className="col-form-label">Transaction Ref </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" name='transactionRef' value={formData.transactionRef} onChange={handleChange} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="paying_amount" className="col-form-label">Paying Amount</label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" name='payingAmt' disabled value={formatMoneyStr(payingAmount)} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="balance" className="col-form-label">Balance</label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" name='balance' disabled value={formatMoneyStr(summaryBalanceDiff())} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="verical-scrl-wrapper common-table paybill-table" id="style-3">
                                            <table className="table table-bordered dataTable" id="dsTable">
                                                <thead>
                                                    <tr>
                                                        <th>Select</th>
                                                        <th>ID</th>
                                                        <th>Raised On</th>
                                                        <th>Type</th>
                                                        <th>Bill No</th>
                                                        <th>Job Ref</th>
                                                        <th>P.O ID</th>
                                                        <th>Supplier (ID)</th>
                                                        <th>Value</th>
                                                        <th>Balance</th>
                                                        <th>Pay</th>
                                                        <th>Due Date</th>
                                                        <th>Created By</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tableRow.map((bill, index) => (
                                                        <tr key={bill.id}>
                                                            <td style={{ width: '5%' }}>
                                                                <label className="checkbox">
                                                                    <input
                                                                        type="checkbox"
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                    <span className="default"></span>
                                                                </label>
                                                            </td>
                                                            <td style={{ width: '5%' }}>
                                                                <a href="#">{bill.id ?? bill.ledger_id ?? bill.purchase_ledger_id ?? ''}</a>
                                                            </td>
                                                            <td style={{ width: '8%' }}>
                                                                {bill.created_date}
                                                            </td>
                                                            <td style={{ width: '5%' }}>
                                                                {bill.type}
                                                            </td>
                                                            <td style={{ width: '10%' }}>
                                                                {bill.bill_no}
                                                            </td>
                                                            <td style={{ width: '10%' }}>
                                                                {bill.job_ref}
                                                            </td>
                                                            <td style={{ width: '8%' }}>
                                                                <Link to={bill.purchase_id ? `/PurchaseHistoryView/${bill.purchase_id}` : '#'}>{bill.reference_no}</Link>
                                                            </td>
                                                            <td style={{ width: '15%' }}>
                                                                <a
                                                                    href="#"
                                                                    className="view-supplier"
                                                                    data-id={bill.supplier_id}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#viewsupplier"
                                                                >
                                                                    {bill.name}
                                                                </a>
                                                            </td>
                                                            <td style={{ textAlign: 'right', width: '5%' }} className="paybill-cell-money">
                                                                {formatMoneyStr(bill.value)}
                                                            </td>
                                                            <td style={{ textAlign: 'right', width: '5%' }} className="paybill-cell-money">
                                                                {formatLedgerBalanceForRow(bill, tableRow, checkedRows)}
                                                            </td>
                                                            <td style={{ textAlign: 'right', width: '8%' }}>
                                                                <input
                                                                    type="text"
                                                                    name="pay[]"
                                                                    className="form-control qtyinputbox"
                                                                    value={bill.pay === '' || bill.pay === null || bill.pay === undefined ? '' : bill.pay}
                                                                    style={{ textAlign: 'right' }}
                                                                    onChange={(e) => handlePayChange(index, e.target.value)}
                                                                    disabled={isPayInputDisabled(bill)}
                                                                    placeholder="Enter Amount"
                                                                    inputMode="decimal"
                                                                />
                                                            </td>
                                                            <td style={{ width: '8%' }}>
                                                                {bill.due_date}
                                                            </td>
                                                            <td style={{ width: '10%' }}>
                                                                {bill.created_by}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <hr />
                                        <a href="#" className="common-closebtn">Cancel</a> &nbsp;
                                        <div className="btn-group bouble-btn" role="group" aria-label="Basic example">
                                            <button onClick={(e) => handleSubmit(e, 'close')} type="button" className="saveclose">Save & Close</button>
                                            <button onClick={(e) => handleSubmit(e, 'new')} type="button" className="savenew">Save & New</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default PayBillsEdit;
